import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_NEW_ROUTE_RESET = 'POST_NEW_ROUTE_RESET';
export const POST_NEW_ROUTE_LOADING = 'POST_NEW_ROUTE_LOADING';
export const POST_NEW_ROUTE_SUCCESS = 'POST_NEW_ROUTE_SUCCESS';
export const POST_NEW_ROUTE_REJECT = 'POST_NEW_ROUTE_REJECT';

//* ACTIONS ------------------------------------------------
export const postNewRouteReset = () => ({ type: POST_NEW_ROUTE_RESET });
export const postNewRouteLoading = () => ({ type: POST_NEW_ROUTE_LOADING });
export const postNewRouteSuccess = (payload) => ({ type: POST_NEW_ROUTE_SUCCESS, payload });
export const postNewRouteReject = (payload) => ({ type: POST_NEW_ROUTE_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postNewRouteRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/api/Route/AddRouteTemplateFile`, options);
};


